var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIos1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.574 75.381c0-3.388.317-6.775-3.07-8.893v-16.09h34.405v16.091c-3.388 2.117-3.07 5.505-3.07 8.893v40.755c0 3.389-.318 6.775 3.07 8.893v16.092H8.504V125.03c3.387-2.117 3.07-5.504 3.07-8.893V75.381zM114.461 115.236c0 22.154-13.762 27.693-33.769 27.693s-33.77-5.539-33.77-27.693V77.514c0-22.154 13.762-27.692 33.77-27.692s33.769 5.538 33.769 27.692v37.722z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.187 116.596c0 .627-.317 7.002 5.505 7.002s5.505-6.375 5.505-7.002V76.05c0-.627.317-6.896-5.505-6.896s-5.505 6.27-5.505 6.896v40.546z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.475 79.24c0-3.936-.1-9.425-5.334-9.425-3.42 0-5.232 2.589-5.232 5.904 0 1.76.201 3.521 1.609 4.971 1.51 1.657 5.334 2.9 7.549 3.521 6.441 1.76 15.096 4.143 20.531 7.871 3.119 2.175 5.434 4.765 6.641 8.492 1.41 3.832 2.014 8.078 2.014 12.223v.414c0 17.088-7.346 29.725-33.01 29.725-10.969 0-22.543-2.176-31.299-9.322v-23.82h26.268c0 5.281-.102 9.217.805 11.082.906 1.76 2.818 2.9 4.83 2.9 3.623 0 5.234-3.625 5.234-6.836 0-9.115-5.535-9.84-12.982-11.703-16.305-4.143-25.463-8.184-25.463-27.343v-1.968c.402-9.528 1.912-14.292 8.957-19.782 5.736-4.453 14.09-5.489 22.141-5.489 11.674 0 22.041 2.382 31.803 9.321v20.921h-25.061V79.24h-.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos1);
export default __webpack_public_path__ + "static/media/ios-1.ec3b76e743c7428fa5f4a49915fdc325.svg";
export { ForwardRef as ReactComponent };